import { Logger, LoggerConnectionStatus } from '@oneappexchange/lwc-wired';
import { IS_DEVELOPMENT, LOGGER_PREFIX, LOGGER_SOURCE, LOGGER_WSS_ENDPOINT } from '~/modules/config';
import { setCrossEnvLogger } from '~/modules/utilities/cross_env_utils';

// extend error fn to allow sending any number of args as a JSON oject
class AppxSiteLogger extends Logger {
    log = this.info;
    // TODO: Document why we're overriding this
    // @ts-expect-error * Automated Type Error Fix
    override error(...args) {
        if (args.length > 1) {
            if (typeof args[0] === 'string') {
                super.error(JSON.stringify({ message: args[0], data: args.length === 2 ? args[1] : args.slice(1) }));
            } else {
                super.error(JSON.stringify({ data: args }));
            }
        } else {
            super.error(args[0]);
        }
    }
    // Use console.debug to print `Awaiting logger socket connection, message enqueued ${finalMessage}`
    // @ts-expect-error * Automated Type Error Fix
    override send(level, message, type = 'log') {
        let stringifiedMessage;
        if (typeof message === 'string') {
            stringifiedMessage = message;
        } else {
            stringifiedMessage = JSON.stringify(message, null, 2);
        }
        const finalMessage = this.prefix ? this.prefix + stringifiedMessage : stringifiedMessage;
        if (level in console) {
            // @ts-expect-error * Automated Type Error Fix
            console[level](finalMessage);
        }
        if (this.status === LoggerConnectionStatus.Closed) {
            return;
        }
        const logMessage = JSON.stringify({
            type,
            level,
            time: Date.now(),
            source: this.source,
            message: finalMessage,
        });
        if (this.status === LoggerConnectionStatus.Connecting) {
            // @ts-expect-error * Automated Type Error Fix
            this.messageQueue.push(logMessage);
            console.debug(`Awaiting logger socket connection, message enqueued.`);
            return;
        }
        // @ts-expect-error * Automated Type Error Fix
        this.logSocket.send(logMessage);
    }
}

export const logger = setCrossEnvLogger(
    new AppxSiteLogger({
        wssEndpoint: LOGGER_WSS_ENDPOINT || '',
        prefix: `[${LOGGER_PREFIX}]: `,
        source: LOGGER_SOURCE,
        developmentMode: IS_DEVELOPMENT,
    }),
);
